import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiPhone, FiCheck, FiAlertOctagon, FiMessageSquare, FiInfo, FiChevronRight } = FiIcons;
import SafeIcon from '../common/SafeIcon';
import toast from 'react-hot-toast';

const CaregiverActionCenter = ({ patient }) => {
  const handleEmergency = () => {
    const confirm = window.confirm("WARNING: Real-time Protocol 4422 Initiation. This will dispatch emergency services.");
    if (confirm) toast.error("EMERGENCY DISPATCH INITIATED", { icon: '🚨' });
  };

  const handleAcknowledge = () => {
    toast.success(`Alert Acknowledged for ${patient?.name || 'Patient'}`);
  };

  return (
    <div className="bg-white p-10 rounded-[3rem] border border-gray-100 shadow-2xl">
      <div className="flex items-center justify-between mb-10">
        <div>
          <h3 className="text-2xl font-black text-gray-900 tracking-tight">Response Center</h3>
          <p className="text-sm text-gray-400 font-bold uppercase tracking-widest mt-1">Actionable Interventions</p>
        </div>
        <div className="px-4 py-2 bg-blue-50 text-blue-600 rounded-xl text-[10px] font-black uppercase tracking-widest flex items-center space-x-2">
          <SafeIcon icon={FiInfo} />
          <span>Caregiver Role Active</span>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <button onClick={handleAcknowledge} className="p-8 bg-emerald-50 text-emerald-700 rounded-[2.5rem] border-2 border-emerald-100 flex flex-col items-center text-center group hover:bg-emerald-600 hover:text-white transition-all shadow-xl">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform">
            <SafeIcon icon={FiCheck} className="text-2xl" />
          </div>
          <span className="font-black text-xs uppercase tracking-widest">Acknowledge Alert</span>
        </button>

        <button className="p-8 bg-blue-50 text-blue-700 rounded-[2.5rem] border-2 border-blue-100 flex flex-col items-center text-center group hover:bg-blue-600 hover:text-white transition-all shadow-xl">
          <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform">
            <SafeIcon icon={FiPhone} className="text-2xl" />
          </div>
          <span className="font-black text-xs uppercase tracking-widest">Contact Clinician</span>
        </button>

        <button onClick={handleEmergency} className="md:col-span-2 p-8 bg-red-600 text-white rounded-[2.5rem] flex items-center justify-between group hover:bg-red-700 transition-all shadow-2xl">
          <div className="flex items-center space-x-6">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center shadow-inner">
              <SafeIcon icon={FiAlertOctagon} className="text-3xl" />
            </div>
            <div className="text-left">
              <h4 className="text-xl font-black uppercase tracking-tighter">Trigger Protocol 4422</h4>
              <p className="text-red-100 text-xs font-bold uppercase tracking-widest mt-1 opacity-80">Immediate 911 Dispatch + GPS Lock</p>
            </div>
          </div>
          <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center group-hover:translate-x-2 transition-transform">
            <SafeIcon icon={FiChevronRight} />
          </div>
        </button>
      </div>
    </div>
  );
};

export default CaregiverActionCenter;